import { useState, useEffect } from 'react';
import logo from '../../assets/banner/home/logo.png';
import icon_home from '../../assets/banner/home/icon_home.svg';
import icon_home_active from '../../assets/banner/home/icon_home_active.svg';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { menuItems } from '../../pages/home/header';

const Header = () => {
    const defaultLanguage = localStorage.getItem('language') || 'vi';
    const [language, setLanguage] = useState(defaultLanguage);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { t, i18n }: any = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname;


    const [activePath, setActivePath] = useState('/');

    useEffect(() => {
        i18n.changeLanguage(defaultLanguage);
        const hash = pathname || window.location.hash || '/';
        setActivePath(hash);
    }, [pathname]);
    const toggleLanguage = (str: string) => {
        const newLang = str;
        setLanguage(newLang);
        localStorage.setItem('language', newLang);
        i18n.changeLanguage(newLang);
    };

    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const handleLinkHome = () => {
        window.scrollTo({ top: 0 })
        navigate('/')
    }
    return (
        <div>
            <header className={`header ${isMenuOpen ? 'menu-open' : ''}`}>
                <div className='hamburger-menu d-none-tablet d-none-mobile' style={{ marginRight: '12px' }} onClick={toggleMenu}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 12H21" stroke="#121212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3 6H21" stroke="#121212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3 18H21" stroke="#121212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className='logo'>
                    <img
                        className='cursor-pointer'
                        onClick={handleLinkHome}
                        src={logo} 
                        alt='DolphinEx'
                        onError={(e) => {
                            console.error('Logo failed to load:', logo);
                            e.currentTarget.style.display = 'none';
                        }} />
                </div>
                <nav onClick={() => setIsMenuOpen(false)}>
                    {
                        <Link onClick={handleLinkHome} to='/'>
                            {
                                activePath === '/' ? <img src={icon_home_active} alt='home' /> : <img src={icon_home} alt='home' />
                            }
                        </Link>
                    }
                    {menuItems.map((item, index) => (
                        <Link
                            key={index}
                            to={item.href}
                            className={activePath.includes(item.href) ? 'active' : ''}
                            onClick={() => {
                                setActivePath(item.href)
                                window.scrollTo({ top: 0 })
                            }}
                        >
                            {t(item.label)}
                        </Link>
                    ))}
                </nav>
                <div className='language-switcher font-tomorrow'>
                    <a className={language === 'vi' ? 'active' : ''} onClick={() => toggleLanguage('vi')} href='#lien-he'>VI</a>
                    <a className={language === 'en' ? 'active' : ''} onClick={() => toggleLanguage('en')} href='#lien-he'>EN</a>
                </div>
            </header>
        </div>
    )
}

export default Header;